import * as yup from 'yup'
export const validationSchema = (t) =>
  yup.object().shape({
    // date: yup.string().required(t('rewards.specialEvent.error.date')),
    // timeStart: yup.string().required(t('rewards.specialEvent.error.timeStart')),
    // timeEnd: yup.string().required(t('rewards.specialEvent.error.timeEnd')),

    // name: yup.string().required(t('rewards.specialEvent.error.nameEvent')),
    point: yup
      .number()
      .typeError(t('rewards.listOperation.isNumber'))
      .required(t('rewards.specialEvent.error.point')),
  })
